const categoryNames = [
  "Online Purchase",
  "Auto Repair",
  "Home Improvement",
  "Debt Collection",
  "Banking or Credit Card",
  "Identity Theft or Fraud",
  "Landlord or Tenant",
  "Utilities or Service Provider",
  "Other Consumer Issue",
  "Refund Not Received",
  "Defective Product",
  "Missing Delivery",
  "Wrong Item Received",
  "Subscription Cancellation",
  "Unauthorized Charge",
  "Price Misrepresentation",
  "Warranty Dispute",
  "Gift Card Issue",
  "Layaway Issue",
  "Door-to-Door Sales",
  "Telemarketing Complaint",
  "Robocalls",
  "Junk Fees",
  "Hidden Fees",
  "False Advertising",
  "Bait and Switch",
  "Price Gouging",
  "Scam or Fraud",
  "Phishing",
  "Imposter Scam",
  "Charity Scam",
  "Lottery or Prize Scam",
  "Romance Scam",
  "Investment Scam",
  "Cryptocurrency Scam",
  "Employment Scam",
  "Rental Scam",
  "Moving Company Dispute",
  "Travel or Airline Issue",
  "Hotel or Lodging Issue",
  "Event Ticket Issue",
  "Gym Membership",
  "Health Club Contract",
  "Medical Billing",
  "Dental Billing",
  "Insurance Billing",
  "Auto Insurance",
  "Health Insurance",
  "Home Insurance",
  "Life Insurance",
  "Mortgage Servicing",
  "Student Loan",
  "Payday Loan",
  "Personal Loan",
  "Auto Loan",
  "Credit Report Error",
  "Credit Repair",
  "Debt Settlement",
  "Wage Garnishment",
  "Repossession",
  "Foreclosure Assistance",
  "Tax Preparation",
  "Check Cashing",
  "Money Transfer",
  "Prepaid Card",
  "Bank Account Freeze",
  "Overdraft Fee",
  "ATM Dispute",
  "Wire Transfer Fraud",
  "Mobile Payment App",
  "Buy Now Pay Later",
  "Internet Service",
  "Cable Service",
  "Cell Phone Service",
  "Electric Utility",
  "Gas Utility",
  "Water Utility",
  "Solar Panel Contract",
  "Security Alarm Contract",
  "Appliance Repair",
  "Furniture Purchase",
  "Mattress Purchase",
  "Clothing or Retail",
  "Grocery or Food Product",
  "Restaurant or Catering",
  "Pet Purchase or Service",
  "Veterinary Billing",
  "Childcare Service",
  "Education or Training Program",
  "Vocational School",
  "Tutoring Service",
  "Professional License Concern",
  "Legal Service Billing",
  "Accounting Service",
  "Real Estate Broker",
  "Property Management",
  "Condo or HOA",
  "Storage Facility",
  "Parking or Towing",
  "Car Rental",
  "Used Car Purchase",
  "New Car Purchase",
  "Auto Warranty",
  "Auto Dealer Financing",
  "Lemon Law Concern",
  "Tire or Parts Issue",
  "Boat or RV Purchase",
  "Motorcycle Purchase",
  "Ride Share Issue",
  "Delivery App Issue",
  "Food Delivery Issue",
  "Home Cleaning Service",
  "Landscaping Service",
  "Snow Removal Service",
  "Pest Control",
  "Plumbing Service",
  "Electrical Service",
  "HVAC Service",
  "Roofing Service",
  "Painting Service",
  "Flooring Service",
  "Window or Door Installation",
  "Kitchen or Bath Remodel",
  "Contract Deposit Dispute",
  "Unfinished Work",
  "Poor Workmanship",
  "Permit or Inspection Issue",
  "Senior Consumer Issue",
  "Veteran Consumer Issue",
  "Disability Access Issue",
  "Language Access Issue",
  "Privacy Concern",
  "Data Breach",
  "Account Hacked",
  "Social Media Marketplace",
  "Online Auction",
  "Marketplace Seller",
  "Digital Download",
  "Software Subscription",
  "App Purchase",
  "Streaming Service",
  "Cloud Storage Service",
  "Domain or Website Service",
  "Business Opportunity",
  "Franchise Issue",
  "Timeshare",
  "Funeral Service",
  "Cemetery Service",
  "Wedding Service",
  "Photography Service",
  "Repair Estimate Dispute",
  "Billing Error",
  "Contract Cancellation",
  "No Response From Business",
  "Threatening Collection Conduct",
  "Harassing Calls",
  "Service Not Provided",
  "Deposit Not Returned",
];

function slugify(value) {
  return value
    .toLowerCase()
    .replace(/&/g, "and")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

function makeCategory(name) {
  return {
    id: slugify(name),
    label: name,
    description:
      name === "Other Consumer Issue"
        ? "Use this option when the consumer issue does not match one of the listed categories."
        : `Consumer issue involving ${name.toLowerCase()}.`,
    questions: [
      "What happened, and when did it happen?",
      "What business or person is involved?",
      "What records, receipts, contracts, photos, or messages do you have?",
      "What outcome are you asking for?",
    ],
    steps: [
      "Write a short timeline of the issue.",
      "Save copies of receipts, contracts, messages, photos, bills, and notices.",
      "Contact the business in writing when appropriate.",
      "Prepare a clear complaint with the requested outcome.",
    ],
    referrals: [
      "Attorney General consumer protection resources",
      "Local consumer assistance office",
      "Appropriate state or federal agency",
    ],
  };
}

export const issueCategories = categoryNames.map(makeCategory);

export const outcomes = [
  "Refund",
  "Repair",
  "Replacement",
  "Cancel contract",
  "Stop billing",
  "Correct account",
  "Return deposit",
  "Remove charge",
  "Stop contact",
  "Written explanation",
  "Other",
];
